import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface SellerRouteProps {
  children: React.ReactNode;
}

export const SellerRoute: React.FC<SellerRouteProps> = ({ children }) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-600" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role !== 'seller') {
    if (user.role === 'admin') return <Navigate to="/admin" replace />;
    if (user.role === 'partner') return <Navigate to="/parceiro" replace />;
    if (user.role === 'maintenance_employee') return <Navigate to="/my-schedule" replace />;
    return <Navigate to="/" replace />;
  }

  if (user.mustChangePassword) {
    return <Navigate to="/change-password" replace />;
  }

  return <>{children}</>;
};
